import React from 'react';
import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';
import { EtatHistorique } from './EtatHistorique';

const fmt = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const fmtD = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR') : '—');
const STYLE = {
  partiel_valide: ['border-emerald-200 bg-emerald-50 text-emerald-800', ShieldCheck],
  acquitte: ['border-emerald-200 bg-emerald-50 text-emerald-800', ShieldCheck],
  impaye: ['border-orange-200 bg-orange-50 text-orange-800', ShieldAlert],
  resilie: ['border-red-200 bg-red-50 text-red-800', ShieldX],
};

export const EtatAttestation = ({ s }) => {
  if (!s.etat_paiement || !s.etat) return null;
  const [cls, Icon] = STYLE[s.etat_paiement];
  return (
    <div className={`rounded-lg border p-3 text-xs space-y-1 ${cls}`} data-testid="etat-attestation">
      <p className="flex items-center gap-2 text-sm font-semibold" data-testid="etat-attestation-label">
        <Icon className="h-4 w-4" /> {s.etat.statut_paiement} — {s.etat.mention}
      </p>
      {s.etat_paiement === 'impaye' && (
        <p data-testid="etat-impaye-info">Réglez l'échéance en retard{s.prochaine_echeance_date ? ` avant le ${fmtD(s.prochaine_echeance_date)}` : ''} pour que votre attestation redevienne valide.</p>
      )}
      {s.etat_paiement === 'resilie' && s.regularisation && (
        <p data-testid="etat-resilie-info">
          Pour réactiver votre contrat : échéances dues {fmt(s.regularisation.echeances_dues)} + contribution suspensive {fmt(s.regularisation.contribution_suspensive)} = <strong>{fmt(s.regularisation.total)}</strong>.
        </p>
      )}
      <EtatHistorique items={s.etat_historique} />
    </div>
  );
};
